import reactDom from 'react-dom'
import '../../style/navbar.css';
import NavItem from './NavItem';
import ProfileBox from './ProfileBox';
import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { openSignup, closeSignup, mobileNavToggle } from '../../actions'
import Logo from '../../images/logo-full.svg';
import LogoPink from '../../images/logo-full-pink.svg';
import LogoMob from '../../images/logo-mobile.svg';
// import LogoMobPink from '../../images/logo-mobile-pink.svg';
import { BASE_URL } from '../../variables'
import { ProfileBoxitem, ProfileBoxitemLogin, ProfileBoxitemMobile, ProfileBoxitemMobileLogin } from '../../variables'
import DesktopThemeSwitcher from '../utils/ThemeSwitcher/Desktop'
    
const Header = (props) => {
    const { loginStatus } = props.authentication
    // let ProfileBoxItemRefDesktop = useRef(ProfileBoxitem)
    // let ProfileBoxItemRefMobile = useRef(ProfileBoxitemMobile)
    let screenWidthRef = useRef(null)
    const navbar = useRef()
    // const [mobileNav, setMobileNav] = useState(screenWidthRef.current > 700 ? false : true)
    const { mobileNavToggle, mobileNav } = props
    useEffect(() => {
        const renderNav = () => {
            const currentWidth = window.innerWidth
            if (currentWidth > 992 && screenWidthRef.current < 992){
                screenWidthRef.current = currentWidth
                mobileNavToggle(false)
                
            }
            else if (currentWidth <= 992 && screenWidthRef.current > 992){
                screenWidthRef.current = currentWidth
                mobileNavToggle(true)

            }
        }
        renderNav()
        window.addEventListener('resize', renderNav)

        return () => {
            window.removeEventListener('resize', renderNav)
        }
    }, [screenWidthRef, mobileNavToggle])
    
    // // sticcky navbar useing on Scroll Event
    // useEffect(() => {
    //     const onScroll = (e) => {
    //         if (window.pageYOffset >= 0 + 75){
    //             navbar.current.classList.add('sticky')
    //             if (mobileNav){
    //                 navbar.current.firstChild.firstChild.firstChild.firstChild.src = LogoMobPink
    //             }
    //             else{
    //                 navbar.current.firstChild.firstChild.firstChild.firstChild.src = LogoPink
    //             }
    //         }
    //         else{
    //             navbar.current.classList.remove('sticky')
    //             if (mobileNav){
    //                 navbar.current.firstChild.firstChild.firstChild.firstChild.src = LogoMob
    //             }
    //             else{
    //                 navbar.current.firstChild.firstChild.firstChild.firstChild.src = Logo
    //             }
    //         }
    //         if (window.pageYOffset >= 0 + 200){
    //             navbar.current.classList.add('animate')
    //         }
    //         else(
    //             navbar.current.classList.remove('animate')
    //         )

    //     }
    //     window.addEventListener('scroll', onScroll)
    //     return () => {
    //         window.removeEventListener('scroll', onScroll)
    //     }
    // }, [mobileNav])

    // Sticky Navbar using IntersectionObserver
    useEffect(() => {
        const animate = (status) => {
            if (status){
                navbar.current.classList.add('animate')
                
            }
            else{
                navbar.current.classList.remove('animate')
            }
        }
        const unStickNav = () => {
            navbar.current.classList.remove('sticky')
            if (mobileNav){
                navbar.current.firstChild.firstChild.firstChild.firstChild.src = LogoMob

            }
            else{
                navbar.current.firstChild.firstChild.firstChild.firstChild.src = Logo
                
            }
        }
        const options = {rootMargin: '200px 0px 0px 0px'}
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting){
                    animate(false)
                    setTimeout(() => unStickNav(), 200)
                    
                }
                else{
                    navbar.current.classList.add('sticky')
                    if (mobileNav){
                        // navbar.current.firstChild.firstChild.firstChild.firstChild.src = LogoMobPink
                        navbar.current.firstChild.firstChild.firstChild.firstChild.src = LogoPink
                        navbar.current.classList.add('stickyMobile')
                        
                    }
                    else{
                        navbar.current.firstChild.firstChild.firstChild.firstChild.src = LogoPink

                    }
                    setTimeout(() => animate(true), 30)
                }
                
            })
        }, options)
        observer.observe(document.getElementById('model'))
    }, [mobileNav])
    return reactDom.createPortal(
        <nav className='navbar' style={{backgroundColor: props.navColor}} ref={navbar}>
            <div className="ui container nav-main">
                <div className="logo">
                    <Link to="/"><img alt="main-logo" src={mobileNav ? LogoMob : Logo} height="55px" /></Link>
                </div>
                <ul className="nav-list">
                    {mobileNav ?  null : <>
                        <NavItem name="Become a Partner" to="/become-a-partner"/>
                        <NavItem name="Blog" to="https://www.dev.corecare.in/blog"/>
                        <NavItem name="Contact" to="/contact"/>
                        <DesktopThemeSwitcher />
                    </>}
                    <ProfileBox profileImage={props.authentication.loginStatus ? `${BASE_URL + props.authentication.photo}` : null} dropDownList={mobileNav ? loginStatus ? ProfileBoxitemMobileLogin : ProfileBoxitemMobile : loginStatus ? ProfileBoxitemLogin : ProfileBoxitem} mobile={mobileNav} authentication={props.authentication}/>
                </ul>
            </div>
        </nav>,
        document.querySelector('#header')
    )
}
const mapStateToProps = (state) => {
    return {
        mobileNav : state.mobileNav,
        authentication: state.Authentication
    }
}
export default connect(mapStateToProps, { openSignup, closeSignup, mobileNavToggle })(Header)